//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import {
  GetSamplingCatalogProductsResponse,
  SamplingCatalogProductsRequest,
  SamplingCatalogProductsResponse,
} from '@apis/campaign-requests/sampling/products/samplingProductsApiV2Model';
import { samplingV2Fetch } from '@apis/campaign-requests/sampling/samplingV2Fetch';
import { makeParams } from '@utils/makeParams';

/**
 * Get products from catalog
 *
 * GET /api/v2/clients/products
 */
export const getSamplingCatalogProducts = async (
  req: SamplingCatalogProductsRequest,
  init?: RequestInit,
): Promise<SamplingCatalogProductsResponse> => {
  const params = makeParams(req);

  const response = await samplingV2Fetch(`/products?${params}`, {
    ...init,
    method: 'GET',
  });

  const data: GetSamplingCatalogProductsResponse = await response.json();
  return data.data;
};
